<template>
    <Layout>
        <div slot="main" class="home-bg">
            <div class="vw-banner-container">
                <img :src="banner" alt="">
            </div>
            <div ref="subNav" class="subnav-area" v-if="subNavList.length > 0">
                <div
                    class="pan-area"
                    v-touch-pan.horizontal.prevent.touch="panNav"
                    :style="{transform: `translate(${leftNav}px, 0)`}"
                >
                    <span :class="['subnav-item', activeIndex===index?'active':'']"
                        v-for="(subnav, index) in subNavList"
                        :key="index"
                        @click="changeNav(index)"
                    >
                        <strong class="block-title">{{isCn?subnav.navigateCnName:subnav.navigateEnName}}</strong>
                        <i class="block-title-line"></i>
                    </span>
                </div>
            </div>
            <div v-show="activeIndex===index" class="content-block" v-for="(subnav, index) in subNavList" :key="index">
                <Sub v-if="subnav.documentUrl === 'aboutSubChina'" cate="1"></Sub>
                <Sub v-if="subnav.documentUrl === 'aboutSubOversea'" cate="2"></Sub>
                <Recruit v-if="subnav.documentUrl === 'aboutRecruit'"></Recruit>
                <Contact v-if="subnav.documentUrl === 'aboutContact'"></Contact>
                <CustomDetail
                    v-if="subnav.documentUrl === 'customSubNav' && subnav.documentType === 1"
                    :pageId="subnav.documentId"
                ></CustomDetail>
                <CustomList
                    v-if="subnav.documentUrl === 'customSubNav' && subnav.documentType === 0"
                    :pageId="subnav.documentId"
                ></CustomList>
            </div>
        </div>
    </layout>
</template>

<script>
import ajax from '@/utils/ajax';
import getLang from '@/utils/main/lang';
import Layout from '@/views/Layout.vue';
import Sub from '@/views/about/Sub.vue';
import Recruit from '@/views/about/Recruit.vue';
import Contact from '@/views/about/Contact.vue';
import CustomDetail from '@/views/detail/CustomDetailBlock.vue';
import CustomList from '@/views/detail/CustomListBlock.vue';

export default {
    name: 'aboutIntro',
    components: {
        Layout,
        Sub,
        Recruit,
        Contact,
        CustomDetail,
        CustomList,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            banner: null,
            bannerTitle: '',
            subNavList: [],
            activeIndex: 0,
            lang: getLang(),
            leftNav: 0,
            minLeftNav: 0,
        };
    },
    computed: {
        serviceTrans() {
            const screenWidth = window.innerWidth;
            return `${-this.serviceIndex * 278 * screenWidth / 375}px`;
        },
        serviceMargin() {
            const screenWidth = window.innerWidth;
            return `${-(this.serviceMarginIndex * 278 - 40) * screenWidth / 375}px`;
        },
    },
    mounted() {
        this.activeIndex = +this.$route.hash.replace('#', '') || 0;
        ajax.get('/web/common/navigate_list.json', { documentUrl: 'about' }).then((result) => {
            this.subNavList = result.data.sonNavigateList;
            this.banner = result.data.parentNavigate.navigateH5Img;
            this.bannerTitle = this.isCn ? result.data.parentNavigate.navigateCnName : result.data.parentNavigate.navigateEnName;
            this.$nextTick(() => {
                this.minLeftNav = this.subNavList.length > 1 ? window.innerWidth - this.$refs.subNav.scrollWidth : 0;
            });
        }).catch(() => {});
    },
    methods: {
        panNav({ evt, ...info }) {
            let tmpLeft = info.delta.x + this.leftNav;
            tmpLeft = Math.min(tmpLeft, 0);
            this.leftNav = Math.max(this.minLeftNav, tmpLeft);
        },
        changeNav(index) {
            this.activeIndex = index;
            this.$router.replace(`#${index}`);
        },
    },
};
</script>
<style lang="less" scoped>
    .home-bg {
        background: #F1F1F1;
    }
    .vw-banner-container {
        width: 100%;
        height: 200px;
        position: relative;
        img {
            width: 100%;
            height: 100%;
        }
        strong {
            position: absolute;
            width: 80%;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 32px;
            color: #fff;
            font-weight: 600;
            text-align: center;
            word-break: break-word;
        }
    }
    .subnav-area {
        text-align: center;
        height: 44px;
        background: #fff;
        width: 100%;
        overflow: hidden;
        .pan-area {
            white-space: nowrap;
            padding: 0 3px;
        }
        .subnav-item {
            display: inline-block;
            color: #9B9B9B;
            padding: 0 12px;
            .block-title {
                display: block;
                padding-top: 8px;
                font-size: 12px;
                font-weight: 500;
                text-align: center;
                white-space: nowrap;
            }
            .block-title-line {
                display: none;
                margin-top: 6px;
                margin: 0 auto;
                width: 22px;
                height: 2px;
                background: #C71F4B;
            }
            &.active .block-title {
                color: #4A4A4A;
                font-weight: 600;
                font-size: 14px;
            }
            &.active .block-title-line {
                display: block;
            }
        }
    }
    .block {
        margin-top: 10px;
        background: #fff;
        padding: 15px;
        .block-title {
            display: block;
            padding-top: 8px;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
        }
        .block-title-line {
            margin-top: 6px;
            display: block;
            margin: 0 auto;
            width: 22px;
            height: 2px;
            background: #C71F4B;
        }
    }
</style>
